import { createFileRoute } from "@tanstack/react-router";
import { Star } from "lucide-react";
import { AdminEmptyTab } from "@/components/dashboard/AdminEmptyTab";

export const Route = createFileRoute("/dashboard/admin/revenue-featured")({
  head: () => ({ meta: [{ title: "Featured · Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <AdminEmptyTab
      title="Featured placements"
      description="Paid featured listings and sponsored placement slots."
      stats={[
        { label: "Active featured" },
        { label: "Revenue (30d)" },
        { label: "Avg. CTR" },
        { label: "Slots available" },
      ]}
      body="Featured placement bookings will appear here."
      primaryAction={{ label: "New placement", icon: Star }}
      columns={["Listing", "Slot", "Starts", "Ends", "Revenue", "Status"]}
    />
  ),
});
